export const RequireKovan = () => {
  return (
    <div>
      Please switch your network to Kovan network to use this application
    </div>
  );
};
